export const API_URL_UPDATE_PORTING_DATES = "/shop/api/porting/update";
